import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-149e9073"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "highlights" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "center" }
const _hoisted_4 = {
  key: 0,
  class: "bg"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "center_list" }
const _hoisted_7 = { class: "item_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 方案亮点功能 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.$Store.Public().isGridMatch('>',_ctx.$Enum.GridEnum.XL))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                src: $data.file.centerImage,
                alt: ""
              }, null, 8 /* PROPS */, _hoisted_5)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "item"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass('item_title_'+(index+1))
              }, _toDisplayString(item.title), 3 /* TEXT, CLASS */),
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.text), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createVNode(_component_a_space, {
        size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_free button_n_1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$Store.Page().openModal('modalOperate','freeUse')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 免费体验 ")
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size"])
    ])
  ]))
}